const iconMap = {
  b: { type: 'bold' },
  blockquote: { type: 'quote' },
  copy: { type: 'copy' },
  delete: { type: 'trash', danger: true },
  edit: { type: 'pencil' },
  visit: { type: 'external-link' },
  i: { type: 'italic' },
  link: { type: 'link' },
  image: { type: 'image' },
  OL: { type: 'list-ol' },
  redo: { type: 'reply', flip: 'horizontal' },
  remove: { type: 'unlink', danger: true },
  strike: { type: 'strikethrough' },
  superscript: { type: 'superscript' },
  UL: { type: 'list' },
  underline: { type: 'underline' },
  undo: { type: 'reply' },
  iframe: { type: 'youtube-play' },
  clearFormatting: { type: 'clear-formatting' }
};

export default iconMap;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/iconMap.js